<template>
	<div class="security_info">
		<div v-if="!this.mobile" class="information_back">
			{{ $store.state.auth.member_info.user_name + $t('merchant.info1') }}
			<span>1{{ $t('merchant.info2') }}</span
			>{{ $t('merchant.info3') }}
			<router-link
				v-if="$route.name !== 'merchant-console-certification-security'"
				class="plus"
				:to="{ name: 'merchant-console-certification-security' }"
			></router-link>
		</div>

		<div v-else class="box base mb_20">
			<span class="icon_box SECURITY"></span>
			<p class="security_level">
				{{ $store.state.auth.member_info.user_name + $t('merchant.info1') }}
				<span>1{{ $t('merchant.info2') }}</span
				>{{ $t('merchant.info3') }}
			</p>
			<a class="icon_box ADD"></a>
		</div>
	</div>
</template>

<script>
import { isMobile } from '@/common/mobile';
export default {
	name: 'SecurityInfo',
	data() {
		return {
			mobile: isMobile(),
		};
	},
};
</script>
